export const MEDICAL_ORDER_GET_REQUEST = 'MEDICAL_ORDER_GET_REQUEST';
export const MEDICAL_ORDER_GET_SUCCESS = 'MEDICAL_ORDER_GET_SUCCESS';
export const MEDICAL_ORDER_GET_ERROR = 'MEDICAL_ORDER_GET_ERROR';
export const MEDICAL_ORDER_GET_BY_KEY_REQUEST = 'MEDICAL_ORDER_GET_BY_KEY_REQUEST';
export const MEDICAL_ORDER_GET_BY_KEY_SUCCESS = 'MEDICAL_ORDER_GET_BY_KEY_SUCCESS';
export const MEDICAL_ORDER_GET_BY_KEY_ERROR = 'MEDICAL_ORDER_GET_BY_KEY_ERROR';
export const MEDICAL_ORDER_ADD_REQUEST = 'MEDICAL_ORDER_ADD_REQUEST';
export const MEDICAL_ORDER_ADD_SUCCESS = 'MEDICAL_ORDER_ADD_SUCCESS';
export const MEDICAL_ORDER_ADD_ERROR = 'MEDICAL_ORDER_ADD_ERROR';
export const MEDICAL_ORDER_EDIT_REQUEST = 'MEDICAL_ORDER_EDIT_REQUEST';
export const MEDICAL_ORDER_EDIT_SUCCESS = 'MEDICAL_ORDER_EDIT_SUCCESS';
export const MEDICAL_ORDER_EDIT_ERROR = 'MEDICAL_ORDER_EDIT_ERROR';
export const MEDICAL_ORDER_DELETE_REQUEST = 'MEDICAL_ORDER_DELETE_REQUEST';
export const MEDICAL_ORDER_DELETE_SUCCESS = 'MEDICAL_ORDER_DELETE_SUCCESS';
export const MEDICAL_ORDER_DELETE_ERROR = 'MEDICAL_ORDER_DELETE_ERROR';
